import { Actor, Color, ScreenElement, vec, Vector, Text, Canvas, Label, Font, BaseAlign, TextAlign, Graphic, Engine, Scene, CollisionGroup } from "excalibur";
import { PointerEvent } from "excalibur/build/dist/Input/PointerEvent";
import { Resources } from "../../resources";
import { collision_groups } from "../../scenes/level-one/collision_groups";
import { LevelOne } from "../../scenes/level-one/level-one";
import { playStart } from "../../util";
import { Path } from "../path";
import { Tower } from "../towers/tower";
import { TowerSpec } from "./tower_specs";

export class TowerCursor extends Actor {    
    private colliding: Set<Actor> = new Set<Actor>();

    constructor(
        private level: LevelOne,
        private towerSpec: TowerSpec,
    ) {        
        super({
            radius: Math.max(towerSpec.icon.width, towerSpec.icon.height) / 3,
            collisionGroup: CollisionGroup.collidesWith([
                collision_groups.towerGroup,
                collision_groups.uiGroup
            ])
        });
    }

    public onInitialize() {
        this.graphics.use(this.towerSpec.icon);

        this.pos = this.scene.engine.input.pointers.primary.lastWorldPos;

        const onPointerMove = (event: PointerEvent) => {
            this.pos = event.worldPos;
        };

        const onPointerUp = (event: PointerEvent) => {
            if (
                this.colliding.size === 0 &&
                !this.isCollidingWithPath() &&
                this.level.money >= this.towerSpec.cost
            ) {
                this.level.money -= this.towerSpec.cost;
                (this.scene as LevelOne).addTower(this.towerSpec.factory(this.level, event.worldPos));
                playStart(Resources.sealPlaced);
                this.kill();
            }
        }

        this.scene.engine.input.pointers.primary.on('move', onPointerMove)
        this.scene.engine.input.pointers.primary.on('up', onPointerUp)

        this.on('kill', () => {
            this.scene.engine.input.pointers.primary.off('move', onPointerMove);
            this.scene.engine.input.pointers.primary.off('up', onPointerUp)
        })

        this.on('collisionstart', (event) => {
            this.colliding.add(event.other);
        });

        this.on('collisionend', (event) => {
            this.colliding.delete(event.other);
        });
    }

    private isCollidingWithPath(): boolean {
        for (let path of this.level.actors) {
            if (path instanceof Path) {
                if (path.collider.get().contains(this.pos)) {
                    return true;
                }
            }
        }
        
        return false;
    }
}